export const PROFESSIONAL_QUOTES = [
  'Consistency compounds. Small daily progress creates major sprint outcomes.',
  'Clarity before speed: a well-defined task finishes faster and cleaner.',
  'Great teams close loops quickly: update status, remove blockers, move forward.',
  'Quality is a team habit, not a last-minute activity.',
  'Progress is momentum: finish one important item, then the next.',
  'Strong delivery comes from focus, communication, and disciplined follow-through.',
  'Escalating early is leadership, not weakness.',
  'A team that communicates daily rarely gets surprised at the end of a sprint.',
  'Done is better than perfect — ship, learn, iterate.',
  'The best sprint review is one where the team is proud of what they built.',
  'Ownership is not assigned; it is assumed by people who care.',
  'Velocity is earned through discipline, not promised through optimism.',
  'Remove one blocker today and watch the whole team move faster tomorrow.',
  'Clear requirements save more time than any tool or framework ever will.',
  'A retrospective without action items is just a conversation.',
  'Predictability is a competitive advantage — teams that deliver on time build trust.',
  'Technical debt is a loan; it must be repaid with interest if left unattended.',
  'The sprint goal is the team\'s compass — keep it visible and keep it honest.',
  'Feedback given early costs nothing; feedback given at release costs everything.',
  'Collaboration is not a meeting; it is a mindset applied across every task.',
  'High-performing teams ask "how can I help?" before "whose job is it?"',
  'Automate what is repetitive so your energy goes toward what is creative.',
  'One open blocker ignored today becomes three blockers by Friday.',
  'The strongest code review comment is a question, not a criticism.',
  'Plan for the work, work the plan, and revisit the plan when reality changes.',
  'Every status update saves at least three follow-up messages.',
  'The most productive teams spend less time in meetings and more time in flow.',
  'A shared definition of "done" prevents a thousand debates at release time.',
  'Team momentum is built by finishing, not just by starting.',
  'Measure outcomes, not activity. Hours logged mean nothing if value is not delivered.',
  'A great team does not need a manager to push them — they pull each other forward.',
  'Bugs found in development cost 10x less than bugs found in production.',
  'Transparency about progress is not a weakness; it is professional maturity.',
  'The backlog is a tool, not a graveyard — groom it, prioritize it, act on it.',
  'Invest five minutes in understanding before spending five hours building the wrong thing.',
  'When in doubt, ship something small and gather real data.',
  'The best architecture is the one that lets the team move fast safely.',
  'Pair on complex problems — two sets of eyes catch twice the edge cases.',
  'A sprint commitment is a team promise, not an individual burden.',
  'Context switching kills flow. Protect your focus like it is your most valuable asset.',
  'Confidence in a deadline comes from breaking work down, not from wishful thinking.',
  'An unresolved assumption is a future bug waiting to be discovered.',
  'Celebrate closed items, not just opened ones.',
  'The team that learns from each sprint improves faster than the team that just executes.',
  'Resilience in delivery comes from process discipline, not from heroics.',
  'Write code as if the next person to read it is you at 3 AM during an incident.',
  'A sprint without a goal is a sprint without a soul.',
  'Every carryover task is a conversation worth having before the sprint ends.',
  'Good engineering is 20% writing code and 80% understanding the problem deeply.',
  'Respect other people\'s time by coming to meetings prepared and leaving with action items.',
  'Continuous improvement is not a quarterly goal — it is a daily habit.',
  'The fastest path to delivery is reducing work-in-progress, not adding more people.',
  'Testing is not the last step; it is every step.',
  'Scope creep is not malicious — it is the result of unclear boundaries. Define them.',
  'Alignment before execution — a misaligned team works hard in the wrong direction.',
  'A pull request is a gift to your team; make it easy to review.',
  'Healthy debate in planning leads to fewer surprises in delivery.',
  'Your estimates are a conversation starter, not a contract.',
  'The best feature to build next is the one that unblocks the most people.',
  'Cross-functional collaboration is a sprint multiplier — use it deliberately.',
  'Ship small, learn fast, improve continuously.',
  'A well-written ticket is the foundation of well-delivered work.',
  'The team that documents as they build rarely scrambles when onboarding new members.',
  'Risk identified early is a risk managed; risk ignored is a deadline missed.',
  'Great products are built by teams that argue about ideas, not about people.',
  'The best time to refactor is during the sprint, not after the release.',
  'Say "I don\'t know" fast, then find out faster.',
  'Delivery consistency builds stakeholder trust more than any single big release.',
  'Engineering excellence and speed are not opposites — discipline makes both possible.',
  'The sprint board is a living document — update it honestly every day.',
  'Lead with data, follow with instinct, decide with courage.',
  'One well-scoped story delivered is worth more than five half-done stories.',
  'Psychological safety in a team unlocks the kind of honesty that prevents disasters.',
  'A team that celebrates small wins sustains motivation across long projects.',
  'Ownership without accountability is wishful thinking.',
  'Great code is written twice: once to make it work, once to make it clear.',
  'The team defines quality — make sure everyone has the same definition.',
  'Dependency management is project management. Map it, track it, resolve it.',
  'When priorities are unclear, everything feels urgent and nothing gets finished.',
  'A bug in production is a process failure, not just a code failure.',
  'Empathy for the user is the most powerful debugging tool available.',
  'The retrospective is the most underrated meeting in agile — treat it with respect.',
  'Engineers who understand the business build more impactful solutions.',
  'Speed without direction is just chaos with momentum.',
  'A team that reviews its own work honestly will rarely be surprised by external audits.',
  'Sustainable pace is not a compromise — it is a strategy for long-term delivery.',
  'Every minute spent on planning saves ten minutes in rework.',
  'The person closest to the problem usually has the best solution — listen to them.',
  'A sprint that ends with honest reflection is a sprint well spent.',
  'Design for the user first; optimise for performance second.',
  'The best teams I have seen are the ones that make each other better every day.',
  'Progress shared is progress doubled — update your team before they have to ask.',
  'Automate your repetitive checks so your energy goes toward solving new problems.',
  'Clarity of purpose turns average effort into exceptional delivery.',
  'If you can explain your task in one sentence, you are ready to start building it.',
  'The team that ships together stays together — shared ownership, shared pride.',
  'Deadlines are not enemies; they are forcing functions for good decision-making.',
  'Technical decisions made in a hurry are revisited at the worst possible time.',
  'A sprint is a hypothesis: we think we can deliver this much value in this time.',
  'Make your work visible — hidden progress is invisible progress.',
  'The fastest way to finish is to know exactly what "finished" looks like.',
  'Review your sprint goal every morning — it keeps the whole team pointed the same direction.',
  'Proactive communication prevents the majority of project escalations.',
  'Small batches of work reduce risk, speed up feedback, and increase confidence.',
  'The best engineers spend as much time reading code as writing it.',
  'Invest in your team\'s well-being; it pays dividends in every sprint.',
  'A handoff without context is a delay in disguise.',
  'Prioritise ruthlessly — you cannot do everything, so choose what matters most.',
  'The goal of a code review is shared understanding, not just catching bugs.',
  'Estimation improves through practice and honest post-sprint comparisons.',
  'Stability in process gives freedom in creativity.',
  'A single shared dashboard removes more confusion than a dozen status emails.',
  'The measure of a great sprint is not velocity — it is value delivered to real users.',
  'Bring solutions, not just problems — it changes the energy of every meeting.',
  'Healthy teams have honest conversations before tensions become conflicts.',
  'Learn from every production incident — not to assign blame, but to build resilience.',
  'Refactoring is not rework; it is investing in tomorrow\'s velocity.',
  'A team that trusts each other ships faster than a team that checks on each other.',
  'Every task you close is a promise kept to your team and your stakeholders.',
  'Code that cannot be tested cannot be trusted.',
  'The sprint demo is your team\'s moment — present it with pride.',
  'Over-communication is almost always better than under-communication in a sprint.',
  'Make the invisible visible: track your work, show your progress, share your blockers.',
  'A culture of accountability is built one kept commitment at a time.',
  'The simplest solution that works is almost always the right one.',
  'Good judgment comes from experience; experience comes from shipping and reflecting.',
  'Shared goals create shared accountability — make sure everyone knows the sprint target.',
  'The team that asks for help promptly finishes faster than the team that suffers in silence.',
  'Reliability is a feature — commit to it as seriously as any other user story.',
  'Every great product started as a messy backlog with a clear vision.',
  'Sprint planning without input from the whole team is just assigning work.',
  'The most important meeting of the sprint is the one where the team defines success.',
  'Iterate on the process as deliberately as you iterate on the product.',
  'A well-maintained backlog is a sign of a well-run team.',
  'Momentum is fragile — protect it by removing friction before it accumulates.',
  'The team that learns in public improves faster than the team that learns in private.',
  'Discipline in the small things — naming, documentation, testing — scales to great systems.',
  'Build relationships within your team; they are the real infrastructure of delivery.',
  'Every unresolved dependency is a future blocker in disguise.',
  'Write the test first when you are unsure what done looks like.',
  'The sprint is not a race against time; it is a race toward value.',
  'Great teams are built on trust, transparency, and a relentless focus on the customer.',
];

export const QUOTE_THEMES = [
  { bg: 'linear-gradient(135deg, #EAF6FD 0%, #e0e7ff 100%)', border: '#7CCAF0', text: '#2C63AE', chipBg: '#a9ddf5' },
  { bg: 'linear-gradient(135deg, #dcfce7 0%, #ccfbf1 100%)', border: '#86efac', text: '#14532d', chipBg: '#bbf7d0' },
  { bg: 'linear-gradient(135deg, #fef3c7 0%, #ffedd5 100%)', border: '#fcd34d', text: '#78350f', chipBg: '#fde68a' },
  { bg: 'linear-gradient(135deg, #fee2e2 0%, #ffe4e6 100%)', border: '#fca5a5', text: '#7f1d1d', chipBg: '#fecaca' },
  { bg: 'linear-gradient(135deg, #ede9fe 0%, #e0e7ff 100%)', border: '#c4b5fd', text: '#4c1d95', chipBg: '#ddd6fe' },
];
